module.exports = __webpack_public_path__ + "static/media/Resume.2dfd24f0.pdf";